import * as React from 'react';
import Box from '@mui/material/Box';
import ViewAdminMessages from './ViewAdminMessages';

const AdminMessageHome = () => {

    return (
        <Box sx={{ width: '100%' }}>
            <ViewAdminMessages />
        </Box>
    );
}

export default AdminMessageHome